import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import MultiLayerFilter from '../../Common/MultiLayerFilter';
import { allFilterPages, formatLocationOptions } from '../../static/filterUtil';

const CollectionLocation = ({ filterPageName }) => {
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const [selectedMultilevelData, setSelectedMultiLevelData] = useState([]);
	const multiLevelFilterStore = useSelector((store) => store.multiLevelFIlterStore);
	const currentSelectedFilterLevel = multiLevelFilterStore?.currentSelectedFilterLevel;

	useEffect(() => {
		onFetchData();
	}, [dependentFilterList]);

	useEffect(() => {
		setSelectedMultiLevelData(multiLevelFilterStore?.multiLevelFilters);
	}, [multiLevelFilterStore]);

	useEffect(() => {
		setData(allData);
	}, [selectedField]);

	const filterData = {
		[allFilterPages.COLLECTION_DETAILS]: dependentFilterList?.sampleInventoryLocationList,
		[allFilterPages.FAVOURITE_DETAILS]: dependentFilterList?.sampleInventoryLocationList
	};

	const onFetchData = async () => {
		let dependentList = filterData[filterPageName];
		const options = formatLocationOptions(
			dependentList || [],
			dependentFilterList?.sampleInventoryCountryList,
			dependentFilterList?.sampleInventoryOnTheWayCount
		);
		setAllData(options);
		setData(options);
	};

	return (
		<MultiLayerFilter
			filterOptions={data}
			selectedField={selectedField}
			selectedMultilevelData={selectedMultilevelData}
			allOptions={allData}
			setFilterOptions={setData}
			currentSelectedFilterLevel={currentSelectedFilterLevel}
			type="COLLECTION_LOCATION"
			isOpenFourthLayerOnSearch={true}
		/>
	);
};

export default CollectionLocation;
